(() => {
  const body = document.body;
  const menu = document.querySelector('[data-menu-panel]');
  const search = document.querySelector('[data-search-panel]');
  const drawer = document.querySelector('[data-cart-drawer]');
  const setOpen = (element, open) => element?.classList.toggle('is-open', open);

  document.querySelectorAll('[data-menu-toggle]').forEach((button) => button.addEventListener('click', () => {
    const open = !menu.classList.contains('is-open');
    setOpen(menu, open); setOpen(search, false); menu.setAttribute('aria-hidden', String(!open));
  }));
  document.querySelector('[data-search-toggle]')?.addEventListener('click', () => {
    const open = !search.classList.contains('is-open');
    setOpen(search, open); setOpen(menu, false); search.setAttribute('aria-hidden', String(!open));
    if (open) search.querySelector('input')?.focus();
  });
  const closeDrawer = () => { setOpen(drawer, false); drawer?.setAttribute('aria-hidden', 'true'); body.classList.remove('drawer-open'); };
  document.querySelector('[data-cart-toggle]')?.addEventListener('click', () => { setOpen(drawer, true); drawer?.setAttribute('aria-hidden', 'false'); body.classList.add('drawer-open'); });
  document.querySelectorAll('[data-close-drawer]').forEach((button) => button.addEventListener('click', closeDrawer));

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }
  function formatMoney(cents) {
    return 'LE ' + Math.round(cents / 100);
  }
  function renderCartDrawer(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    const totalEl = document.querySelector('[data-cart-total]');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    const cartBody = document.querySelector('[data-cart-body]');
    if (!cartBody) return;
    if (cart.item_count === 0) {
      cartBody.innerHTML = '<div class="cart-empty"><span class="cart-empty-mark">+</span><p>Your cart is empty.</p><small>ADD SOMETHING STRIKING.</small></div>';
      return;
    }
    const changeUrl = (drawer && drawer.getAttribute('data-cart-change-url')) || '/cart/change';
    let html = '';
    cart.items.forEach((item, index) => {
      html += '<div class="cart-line">' +
        '<img src="' + item.image + '" width="160" height="160" alt="' + escapeHtml(item.product_title) + '">' +
        '<div class="cart-line-info"><strong>' + escapeHtml(item.product_title) + '</strong>' +
        '<small>' + escapeHtml(item.variant_title || '') + '</small>' +
        '<div class="cart-line-bottom"><span>' + formatMoney(item.final_line_price) + '</span><small>QTY ' + item.quantity + '</small></div>' +
        '<a class="cart-remove" href="' + changeUrl + '?line=' + (index + 1) + '&quantity=0">REMOVE</a></div></div>';
    });
    cartBody.innerHTML = html;
  }
  drawer?.addEventListener('click', (e) => {
    const link = e.target.closest('.cart-remove');
    if (!link) return;
    e.preventDefault();
    const url = new URL(link.href, window.location.origin);
    const line = url.searchParams.get('line');
    const quantity = url.searchParams.get('quantity') || '0';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then((res) => res.json())
      .then((cart) => renderCartDrawer(cart));
  });

  const variantsNode = document.querySelector('[data-product-variants]');
  const variantId = document.querySelector('[data-variant-id]');
  const optionInputs = document.querySelectorAll('.product-option-input');
  if (variantsNode && variantId && optionInputs.length) {
    const variants = JSON.parse(variantsNode.textContent);
    const price = document.querySelector('[data-product-price]');
    const compare = document.querySelector('[data-product-compare]');
    const addButton = document.querySelector('.product-add');
const money = (value) => `${value / 100} EGP`;
    const syncVariant = () => {
      const selected = [...optionInputs].reduce((options, input) => {
        if (input.checked) options[Number(input.dataset.optionPosition)] = input.value;
        return options;
      }, []);
      const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
      if (!variant) return;
      variantId.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (compare) { compare.textContent = money(variant.compare_at_price || 0); compare.hidden = !(variant.compare_at_price > variant.price); }
      if (addButton) { addButton.disabled = !variant.available; addButton.firstChild.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT'; }
    };
    optionInputs.forEach((input) => input.addEventListener('change', syncVariant));
  }
  const observer = new IntersectionObserver((entries) => entries.forEach((entry) => entry.isIntersecting && entry.target.classList.add('revealed')), { threshold: .12 });
  document.querySelectorAll('[data-reveal]').forEach((element) => observer.observe(element));
})();
const colorInputs = [...document.querySelectorAll('input[type="radio"][name^="option-"]')];

const getColorInputs = () => {
  return colorInputs.filter((input) => {
    const fieldset = input.closest('.product-option-group');
    return fieldset && fieldset.querySelector('legend')?.textContent.trim().toLowerCase() === 'color';
  });
};

const getColorOrder = () => {
  return getColorInputs().map((input) => input.value.trim().toLowerCase());
};

const getSelectedColor = () => {
  const selected = getColorInputs().find((input) => input.checked);
  return selected ? selected.value.trim().toLowerCase() : null;
};

const getImageColor = (item) => {
  return (item.dataset.imageAlt || '').trim().toLowerCase();
};

const selectColor = (color) => {
  const input = getColorInputs().find(
    (input) => input.value.trim().toLowerCase() === color
  );

  if (input && !input.checked) {
    input.click();
  }
};

document.querySelectorAll('.gallery-track').forEach((track) => {
  const wrapper = track.closest('.product-gallery');
  const prevBtn = wrapper?.querySelector('.gallery-prev');
  const nextBtn = wrapper?.querySelector('.gallery-next');

  if (!wrapper || !prevBtn || !nextBtn) return;

  const slides = [...track.querySelectorAll('.product-media-item')];

  const colorOrder = getColorOrder();

  const orderedSlides = [];

  colorOrder.forEach((color) => {
    slides.forEach((slide) => {
      const imageColor = getImageColor(slide);

      if (imageColor.includes(color)) {
        orderedSlides.push(slide);
      }
    });
  });

  orderedSlides.forEach((slide) => track.appendChild(slide));

  let currentIndex = 0;

  const getSlides = () => [...track.querySelectorAll('.product-media-item')];

  const getCurrentIndex = () => {
    const currentSlides = getSlides();

    if (!currentSlides.length) return 0;

    const scrollLeft = track.scrollLeft;

    let closestIndex = 0;
    let closestDistance = Infinity;

    currentSlides.forEach((slide, index) => {
      const distance = Math.abs(slide.offsetLeft - scrollLeft);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  };

  const goToSlide = (index) => {
    const currentSlides = getSlides();

    if (!currentSlides[index]) return;

    currentSlides[index].scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start'
    });
  };

  nextBtn.addEventListener('click', () => {
    const currentSlides = getSlides();

    currentIndex = getCurrentIndex();

    if (currentIndex >= currentSlides.length - 1) return;

    const nextIndex = currentIndex + 1;
    const nextSlide = currentSlides[nextIndex];

    const nextColor = getImageColor(nextSlide);
    const currentColor = getSelectedColor();

    if (nextColor && nextColor !== currentColor) {
      const nextColorInput = getColorInputs().find((input) =>
        nextColor.includes(input.value.trim().toLowerCase())
      );

      if (nextColorInput) {
        nextColorInput.click();
      }
    }

    goToSlide(nextIndex);
  });

  prevBtn.addEventListener('click', () => {
    const currentSlides = getSlides();

    currentIndex = getCurrentIndex();

    if (currentIndex <= 0) return;

    const previousIndex = currentIndex - 1;
    const previousSlide = currentSlides[previousIndex];

    const previousColor = getImageColor(previousSlide);
    const currentColor = getSelectedColor();

    if (previousColor && previousColor !== currentColor) {
      const previousColorInput = getColorInputs().find((input) =>
        previousColor.includes(input.value.trim().toLowerCase())
      );

      if (previousColorInput) {
        previousColorInput.click();
      }
    }

    goToSlide(previousIndex);
  });
});